import React, { useEffect, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import style from './bladeopener.module.css'
import { RaceDTO } from '../../../interfaces/RaceDTO';
import BladeOpenerButtonRow, { ImtStatus } from './BladeOpenerButtonRow';
import { useBlade } from '../../../services/BladeProvider';
import { ViewProp, ViewType } from '../../../interfaces/internal/ViewProps';
import BladeOpenerListItem from './BladeOpenerListItem';

interface Props {
    onExit: () => void;
    race: RaceDTO;
}
interface ImtRows {
    [key: string]: ImtStatus;
}
interface vOpens {
    athletebio: boolean;
    resultanalytics: boolean;
    teamdata: boolean;
};
const BladeOpenerModal = ({ onExit, race }: Props) => {
    const { existsBlade, removeBlade, blades, addBlade, setFocusedBlade, addBlades } = useBlade();
    const [blad, setBlad] = useState<ImtRows>({});
    const [windowHeight, setWindowHeight] = useState<number>(window.innerHeight);

    const [oddBlad, setOddBlad] = useState<vOpens>({
        athletebio: false,
        resultanalytics: false,
        teamdata: false
    });
    useEffect(() => {
        const handleResize = () => {
            setWindowHeight(window.innerHeight -50);
          };
      
          // Add event listener for window resize
          window.addEventListener('resize', handleResize);
      
          // Cleanup function to remove the event listener
          return () => {
            window.removeEventListener('resize', handleResize);
          };
      
    },[])

    const onSave = () => {
        Object.keys(blad).map((obj) => {
            const bla = blad[obj];
            Object.keys(bla).map((bl) => {
                let id = existsBlade(parseInt(obj), parseInt(bl));
                if (id && id >= 0) {
                    removeBlade(id);
                }
            })
        });
        let id: number = 1;
        let order: number = 1;
        let vprop: ViewProp[] = [];
        if (blades.length > 0) {
            id = Math.max(...blades.map((o) => o.id)) + 1;
            order = Math.max(...blades.map((o) => o.order)) + 1;
        }
        if (oddBlad.athletebio) {
            id += 1;
            order += 1;
            vprop.push(handleOpenChange(ViewType.athletebio, null, null, id, order, true, true));
        }
        if (oddBlad.resultanalytics) {
            id += 1;
            order += 1;
            vprop.push(handleOpenChange(ViewType.resultAnalytics, null, null, id, order, true, true));
        }
        if (oddBlad.teamdata) {
            id += 1;
            order += 1;
            vprop.push(handleOpenChange(ViewType.teamdata, null, null, id, order, true, true));
        }
        Object.keys(blad).map((obj) => {
            const bla = blad[obj];
            Object.keys(bla).map((bl) => {
                if (bla[bl]) {
                    id += 1;
                    order += 1;
                    vprop.push(handleOpenChange(ViewType.resultPretime, parseInt(obj), parseInt(bl), id, order, true, true));
                }
            })
        });
        addBlades(vprop);
        onExit();
    }
    const handleOpenChange = (viewdat: ViewType, classid: number | null, ipos: number | null, order: number, id: number, maximized: boolean, fullheight: boolean): ViewProp => {
        const viProp: ViewProp = {
            id: id,
            name: "",
            Vtype: viewdat,
            color: "black",
            order: order,
            width: null,
            height: null,
            autoOpened: false,
            classId: classid,
            level: 1,
            ipos: ipos,
            athleteid: null,
            maximized: false,
            fullheight: fullheight,
            heightprocent: fullheight ? "100%" : "50%",
            focused: false,
            hideMenu: true,
        };
        return viProp;
    };
    const onchangedImt = (clid: string, imt: ImtStatus) => {
        setBlad(prev => {
            let nextPrev = { ...prev };
            nextPrev[clid] = imt;
            return nextPrev;
        })
    }
    const clickedBlade = (vType: ViewType) => {
        setOddBlad((prev) => {
            let newprev = { ...prev };
            switch (vType) {
                case ViewType.athletebio:
                    newprev.athletebio = !newprev.athletebio; // Toggle athletebio
                    break;
                case ViewType.resultAnalytics:
                    newprev.resultanalytics = !newprev.resultanalytics; // Toggle resultanalytics
                    break;
                case ViewType.teamdata:
                    newprev.teamdata = !newprev.teamdata; // Toggle teamdata (assuming this was intended)
                    break;
                default:
                    // Optional: Handle unexpected vType values, e.g., logging
                    break;
            }
            return newprev;
        });
    };


    return (
        <div
            className="modal show"
            style={{
                display: "block",
                position: "fixed",
                background: "rgb(255 255 255 / 20%)",
                zIndex: "999",
                height: windowHeight,
                maxHeight: windowHeight
            }}
        >
            <Modal.Dialog style={{ marginTop: "0%" }}>
                <Modal.Header style={{ color: "black", paddingBottom: "3px", paddingTop: "5px" }}>
                    <div className={style.header}>Select the classes and intermediates you want to show you can also open analytics, bios, and team results</div>
                </Modal.Header>
                <Modal.Body style={{height: `CALC(${windowHeight}px - 160px`, overflow: "auto"}}>
                    {Object.keys(race.Class).map((obj, index) => (
                        <BladeOpenerButtonRow onchangedImt={(inp) => onchangedImt(obj, inp)} key={"bl_" + obj} classes={race.Class[parseInt(obj)]} />
                    ))}
                    <div className={style.class_box}>
                        <div>
                            <span className={style.header}>Open different blades</span>
                        </div>
                        <div className={"btn-group btn-group-sm " + style.class_button_group} role="group" aria-label="...">
                            <ul className={"list-group " + style.list_box}>
                                <BladeOpenerListItem onClicked={clickedBlade} text='Bio, athlete analytics and historic results' vtype={ViewType.athletebio} isSelected={oddBlad.athletebio} />
                                <BladeOpenerListItem onClicked={clickedBlade} text='Analytics results' vtype={ViewType.resultAnalytics} isSelected={oddBlad.resultanalytics} />
                                <BladeOpenerListItem onClicked={clickedBlade} text='Team results, You see an summerize of a club´s results' vtype={ViewType.teamdata} isSelected={oddBlad.teamdata} />
                            </ul>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={onExit} variant='danger'>Exit</Button>
                    <Button onClick={onSave}>Open</Button>
                </Modal.Footer>
            </Modal.Dialog>
        </div>
    )
}

export default BladeOpenerModal